import { useCallback, useEffect } from 'react'
import { playSound, preloadSound } from '@/src/renderer/lib/sounds/audioEngine'

/**
 * Low-level hook for playing a preloaded UI sound.
 * Don't use this directly — import named hooks from `@/src/renderer/lib/sounds` instead.
 *
 * Backed by a shared AudioContext (see `audioEngine.ts`), so mounting this
 * hook in N components creates 0 WebMediaPlayers and supports overlapping
 * playback.
 */
export function useSound(src: string, options: { volume?: number } = {}) {
  const { volume = 0.5 } = options

  useEffect(() => {
    preloadSound(src)
  }, [src])

  return useCallback(() => {
    void playSound(src, volume)
  }, [src, volume])
}
